<template>
    <div class="dropdown">
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
                <a
                    :class="['nav-link', 0 == isActive ? 'active' : '']"
                    @click="changeTab(0)"
                    href="#basic"
                    role="tab"
                    >Ventas anuales</a
                >
            </li>

            <li class="nav-item">
                <a
                    :class="['nav-link', 1 == isActive ? 'active' : '']"
                    @click="changeTab(1)"
                    href="#faq"
                    role="tab"
                    >Fuentes de financiamiento</a
                >
            </li>

            <li class="nav-item">
                <a
                    :class="['nav-link', 2 == isActive ? 'active' : '']"
                    @click="changeTab(2)"
                    href="#adward"
                    role="tab"
                    >Niveles de educación</a
                >
            </li>
            <li class="nav-item">
                <a
                    :class="['nav-link', 3 == isActive ? 'active' : '']"
                    @click="changeTab(3)"
                    href="#ally"
                    role="tab"
                    >Ocupaciones</a
                >
            </li>
            <li class="nav-item">
                <a
                    :class="['nav-link', 4 == isActive ? 'active' : '']"
                    @click="changeTab(4)"
                    href="#ally"
                    role="tab"
                    >Donde estudia</a
                >
            </li>

            <li class="nav-item">
                <a
                    :class="['nav-link', 5 == isActive ? 'active' : '']"
                    @click="changeTab(5)"
                    href="#phase"
                    role="tab"
                    >Fases</a
                >
            </li>
        </ul>

        <div class="tab-content">
            <div
                :class="['tab-pane', 0 == isActive ? 'active' : '']"
                id="basic"
                role="tabpanel"
            >
                <annual-sale-component
                    v-if="0 == isActive"
                    v-bind:model_id="model_id"
                ></annual-sale-component>
            </div>
            <div
                :class="['tab-pane', 1 == isActive ? 'active' : '']"
                id="faq"
                role="tabpanel"
            >
                <funding-source-component
                    v-if="1 == isActive"
                    v-bind:model_id="model_id"
                ></funding-source-component>
            </div>
            <div
                :class="['tab-pane', 2 == isActive ? 'active' : '']"
                id="adward"
                role="tabpanel"
            >
                <education-level-component
                    v-if="2 == isActive"
                    v-bind:model_id="model_id"
                ></education-level-component>
            </div>
            <div
                :class="['tab-pane', 3 == isActive ? 'active' : '']"
                id="ally"
                role="tabpanel"
            >
                <occupation-component
                    v-if="3 == isActive"
                    v-bind:model_id="model_id"
                ></occupation-component>
            </div>
            <div
                :class="['tab-pane', 4 == isActive ? 'active' : '']"
                id="ally"
                role="tabpanel"
            >
                <university-list-component
                    v-if="4 == isActive"
                    v-bind:model_id="model_id"
                ></university-list-component>
            </div>
            <div
                :class="['tab-pane', 5 == isActive ? 'active' : '']"
                id="phase"
                role="tabpanel"
            >
                <phase-component
                    v-if="5 == isActive"
                    v-bind:model_id="model_id"
                ></phase-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            tab: 0,
        };
    },
    computed: {
        isActive: function () {
            return this.tab;
        },
    },
    methods: {
        changeTab(value) {
            if (this.tab != value) {
                this.tab = value;
            }
        },
    },
    mounted() {},
};
</script>
